var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card-actions', {
    attrs: {
      "action-collapse": "",
      "title": "Daftar Teritori"
    }
  }, [_c('b-row', {
    staticClass: "align-items-end mb-1"
  }, [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "3",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Per halaman",
      "label-for": "perPageSelect"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "perPageSelect",
      "size": "sm",
      "options": _vm.pageOptions
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  })], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "5",
      "sm": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Cari",
      "label-for": "filterInput"
    }
  }, [_c('b-input-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "filterInput",
      "type": "search",
      "placeholder": "Cari teritori..."
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.applySearch($event);
      }
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.clearSearch
    }
  }, [_vm._v(" Clear ")])], 1)], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1 d-flex justify-content-md-end",
    attrs: {
      "md": "4",
      "sm": "12"
    }
  }, [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(113, 102, 240, 0.15)',
      expression: "'rgba(113, 102, 240, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.add
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah ")], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-teritori",
      "centered": "",
      "title": _vm.id ? 'Form Ubah' : 'Form Tambah',
      "hide-footer": ""
    },
    model: {
      value: _vm.showModal,
      callback: function callback($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('b-form', [_c('b-form-group', {
    attrs: {
      "label": "Nama Teritori",
      "label-for": "nama_teritori"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "nama_teritori",
      "placeholder": "Nama teritori"
    },
    model: {
      value: _vm.form.nama_teritori,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nama_teritori", $$v);
      },
      expression: "form.nama_teritori"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Keterangan (Opsional)",
      "label-for": "keterangan"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "keterangan",
      "placeholder": "Keterangan",
      "rows": "3"
    },
    model: {
      value: _vm.form.keterangan,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "keterangan", $$v);
      },
      expression: "form.keterangan"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary",
      "disabled": _vm.saving
    },
    on: {
      "click": function click($event) {
        _vm.showModal = false;
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm.saving ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.saving ? "Menyimpan..." : _vm.id ? "Ubah" : "Simpan") + " ")], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [!_vm.loading && !_vm.items.length ? _c('div', {
    staticClass: "text-center text-muted py-4 border rounded"
  }, [_vm._v(" Belum ada data teritori "), _vm.filter ? _c('span', [_vm._v(" untuk pencarian “" + _vm._s(_vm.filter) + "”")]) : _vm._e(), _vm._v(". ")]) : _c('b-table', {
    attrs: {
      "striped": "",
      "small": "",
      "hover": "",
      "responsive": "",
      "items": _vm.items,
      "fields": _vm.fields,
      "show-empty": "",
      "empty-text": "Tidak ada data"
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(row) {
        return [_c('strong', [_vm._v(" " + _vm._s((_vm.currentPage - 1) * _vm.perPage + row.index + 1) + " ")])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(row) {
        return [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Ubah',
            expression: "'Ubah'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "EditIcon"
          }
        })], 1), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Hapus',
            expression: "'Hapus'",
            modifiers: {
              "hover": true,
              "right": true
            }
          }],
          attrs: {
            "size": "sm",
            "variant": "outline-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(row.item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1)];
      }
    }])
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-between align-items-center mt-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Total " + _vm._s(_vm.totalRows) + " data")]), _c('b-pagination', {
    staticClass: "my-0",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "size": "sm"
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }